const CardSkeleton = () => {
    return (
        <div className="group p-4 rounded-xl shadow-lg bg-white flex flex-col h-full animate-pulse">
            <div className="w-full mb-3 relative overflow-hidden rounded-lg aspect-square bg-gray-200">
            </div>
            <div className="p-2 flex-grow">
                <div className="bg-gray-200 h-5 rounded w-4/5 mb-2"></div>
                <div className="bg-gray-200 h-6 rounded w-1/2 mb-4"></div>
            </div>

            <div className="bg-gray-200 h-10 rounded"></div>
        </div>
    );
};

export default CardSkeleton;